import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import get from "@insite/mobius/utilities/get";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {
    fields: {
        [fields.textFieldValue]: string;
        [fields.multilineTextFieldValue]: string;
        [fields.imagePickerFieldValue]: any;
        [fields.background]: "image";
        [fields.image]: string;
    };
}

const enum fields {
    textFieldValue = "textFieldValue",
    multilineTextFieldValue = "multilineTextFieldValue",
    imagePickerFieldValue = "imagePickerFieldValue",
    background = "background",
    image = "image",
}
const backgroundStyles = "";

export interface BannerStyles {
    container?: InjectableCss;
    BannerImg?: InjectableCss;
    headeingSaveOn?: InjectableCss;
    ContainerBackgroundImage?: InjectableCss;
    container2?: InjectableCss;
}

const bannerStyles: BannerStyles = {
    BannerImg: {
        css: css`
            // background-color:#ececec;
            width: 100%;
        `,
    },
    container2: {
        css: css`
            padding: 10px;
            > div > div[class^="GridWrapper"] {
                max-width: 1350px;
                > div[class^="GridOffset"] {
                    width: 100%;
                    margin-left: auto;
                    margin-right: auto;
                    > div[class^="GridItemStyle"] {
                        max-width: 1330px;
                        margin-left: auto;
                        margin-right: auto;
                    }
                    > div[class^="GridItemStyle"]:first-child {
                        padding-left: 0;
                        padding-right: 0;
                        max-width: 100%;
                    }
                }
            }
        `,
    },
    container: {
        css: css`
            padding: 40px 0;
        `,
    },
    headeingSaveOn: {
        css: css`
            font-size: 28px;
            font-weight: bold;
        `,
    },
};

const PromoBanner: React.FC<Props> = props => {
    const InnerbannerStyles: BannerStyles = {
        ContainerBackgroundImage: {
            css: css`
                text-align: center;
                padding: 100px;
                color: #000;
                font-weight: 700;
                background-image: url(${props.fields.imagePickerFieldValue});
                background-attachment: fixed;
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                opacity: 0.8;
                box-shadow: rgba(255, 255, 255, 0.6) 0px 0px 0px 1000px inset;
            `,
        },
    };
    return (
        <>
            <StyledWrapper {...bannerStyles.container}>
                <StyledWrapper {...bannerStyles.BannerImg}>
                    <StyledWrapper {...InnerbannerStyles.ContainerBackgroundImage}>
                        <StyledWrapper {...bannerStyles.headeingSaveOn}>{props.fields.textFieldValue}</StyledWrapper>

                        <StyledWrapper {...bannerStyles.container2}>
                            {props.fields.multilineTextFieldValue}
                        </StyledWrapper>
                        <StyledWrapper {...bannerStyles.container2}>
                            <Link href="/Products">
                                <Button>Shop Today</Button>
                            </Link>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.textFieldValue,
            displayName: "Text",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "text tip",
            placeholder: "text placeholder",
            isRequired: true,
        },
        {
            name: fields.multilineTextFieldValue,
            displayName: "MultilineText",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "multi line tip",
            placeholder: "multi line placeholder",
            isRequired: true,
        },
        {
            name: fields.imagePickerFieldValue,
            displayName: "File",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            isRequired: true,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: PromoBanner,
    definition,
};

export default widgetModule;
